import { render, staticRenderFns } from "./SelecionarTemplate.vue?vue&type=template&id=5c859d4c&scoped=true&"
import script from "./SelecionarTemplate.vue?vue&type=script&lang=js&"
export * from "./SelecionarTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c859d4c",
  null
  
)

export default component.exports